<template>
  <form @submit.prevent="updateNote();">
    <div class="internal-notes-editor">
      <RichTextEditor
        ref="editor"
        v-model="editorContent"
        input-id="internal_notes_text_entry_body"
        input-name="internal_notes_text_entry[body]"
        variant="internal"
        :placeholder="$t('Add a note for your team...')"
        :enable-image-upload="true"
        :enable-embeds="false"
        :enable-drafts="true"
        :draft-id="`internal_notes_${postId}`"
      />

      <div class="flex items-center justify-between mt-3">
        <p v-if="updatedAt" class="text-xs text-neutral-600">
          {{ $t('Last saved') }} {{ formattedUpdatedAt }}
        </p>
        <div v-else></div>
        <button
          type="submit"
          id="internal-notes-btn"
          class="btn-main text-sm"
          :disabled="isSaving || !hasChanges"
        >
          {{ isSaving ? $t('Saving...') : $t('Save') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { RichTextEditor } from "./components/rich_text_editor";
import { formatDistance } from "date-fns";
import datefnLocales from "./locales/datefnlocales";

export default {
  props: ["initial-content", "post-id", "board-id", "project-id", "updated-at"],

  data: function() {
    return {
      editorContent: this.initialContent || "",
      originalContent: this.initialContent || "",
      isSaving: false
    };
  },

  components: {
    RichTextEditor
  },

  computed: {
    hasChanges() {
      return this.editorContent !== this.originalContent;
    },
    formattedUpdatedAt() {
      if (!this.updatedAt) return '';
      return formatDistance(new Date(this.updatedAt), new Date(), {
        locale: datefnLocales[this.$root.$i18n.locale],
        addSuffix: true,
      });
    }
  },

  methods: {
    async updateNote() {
      if (this.isSaving || !this.hasChanges) return;
      this.isSaving = true;

      let data = new FormData();
      data.append("project_id", this.projectId);
      data.append("board_id", this.boardId);
      data.append("post_id", this.postId);
      data.append("internal_notes", this.editorContent);

      Rails.ajax({
        url: `/boards/${this.boardId}/posts/${this.postId}/internal_notes`,
        type: "PUT",
        data: data,
        dataType: "json",
        processData: true,
        beforeSend: function() {
          return true;
        },
        success: data => {
          this.editorContent = data.internal_notes;
          this.originalContent = data.internal_notes;
          this.updatedAt = data.updated_at;
          this.$refs.editor?.clearDraft();
          this.isSaving = false;
        },
        error: (data, status) => {
          this.isSaving = false;
          console.error("Note was not updated");
          alert("Failed to save note. Please try again.");
        }
      });
    }
  }
};
</script>
